import { DeleteModalService } from './../../services/delete-modal.service';
import { DeleteModalComponent } from './../../../shared/delete-modal/delete-modal.component';
import { BodypartsModalComponent } from './../../../shared/bodyparts-modal/bodyparts-modal.component';
import { MasterService } from './../../services/master.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PaginationInstance } from 'ngx-pagination';
import {CommonAlertService} from "../../../services/common-alert.service";

@Component({
  selector: 'app-bodyparts',
  templateUrl: './bodyparts.component.html',
  styleUrls: ['./bodyparts.component.scss']
})
export class BodypartsComponent implements OnInit {

  public bodyParts: any;
  public filter: any;
  // tslint:disable-next-line:variable-name
  total_count: number;
  // tslint:disable-next-line:variable-name
  current_page: number;
  // tslint:disable-next-line:variable-name
  last_page: number;
  // tslint:disable-next-line:variable-name
  per_page: number;
  pageEvent: PageEvent;
  public selectedIndex = 0;
  public searchBy: any = 0;
  public searchTxt: any;
  stockPageId = 'stockPageId';
  placeHolder: any = 'Search By Body Part';

  @Input() id: string;
  @Input() maxSize: number;
  @Output() pageChange: EventEmitter<number>;
  itemToBePushed: any;

  public config: PaginationInstance = {
    id: 'custom',
    itemsPerPage: 10,
    currentPage: 1
  };

  public childMessage = 'listing_pagination';
  bool = false;
  public viewPermission = false;
  public addPermission = false;
  public editPermission = false;
  public deletePermission = false;
  // tslint:disable-next-line:max-line-length
  constructor(public masterservice: MasterService, public dialog: MatDialog, public deleteModalService: DeleteModalService, public commonAlertService: CommonAlertService) { }

  ngOnInit() {
    // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (localStorage.getItem('roleId') == 0) {
      // @ts-ignore
      // tslint:disable-next-line:max-line-length
      this.viewPermission = this.addPermission = this.editPermission = this.deletePermission = true;
    } else {
      const roles = JSON.parse(localStorage.getItem('roles'));
      // tslint:disable-next-line:triple-equals max-line-length
      if (roles['more.body_parts.view'] == 1 || roles['more.body_parts.add'] == 1 || roles['more.body_parts.edit'] == 1 || roles['more.body_parts.delete'] == 1) {
        this.viewPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['more.body_parts.add'] == 1) {
        this.addPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['more.body_parts.edit'] == 1) {
        this.editPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['more.body_parts.delete'] == 1) {
        this.deletePermission = true;
      }
    }
    this.filter = {
      token: localStorage.getItem('token')
    };
    this.filter = {
      token: localStorage.getItem('token')
    };
    this.getBodyPartsData();
  }

  getBodyPartsData() {
    this.masterservice.getIndex('/body_parts/index', this.filter).subscribe(res => {
      // @ts-ignore
      this.bodyParts     = res.data.items;
      // @ts-ignore
      this.total_count   = res.data.total;
      // @ts-ignore
      this.last_page = res.data.last_page;
      // @ts-ignore
      this.per_page      = res.data.per_page;
      this.itemToBePushed = (this.last_page * this.per_page) - this.total_count;
      this.total_count = this.total_count + (this.last_page * this.per_page - this.total_count);
      // @ts-ignore
      this.current_page  = res.data.current_page;
      this.bool = true;
      const newData = { name: ''};

      if (this.bodyParts.length < this.per_page) {
        for ( let i = 0; i < this.itemToBePushed ; i++) {
          this.bodyParts.push(newData);
        }
      }
      // @ts-ignore
      if(res.data.total == 0){
       this.commonAlertService.showEmptyMsg({message: 'No Details Found.'})
      }
    });

  }

  getSearchValue() {
    if (this.searchBy) {
      switch (this.searchBy) {
        case '0':
          this.placeHolder = 'Search By Body Part';
          break;
        default: this.placeHolder = 'Search By Body Part';
      }
    }
  }

  editDialog(i) {
    const editId = this.bodyParts[i].id;
    const encID = this.bodyParts[i].enc_id;
    // tslint:disable-next-line:triple-equals
    const dialogRef = this.dialog.open(BodypartsModalComponent, {
      minWidth: '60vw',
      minHeight: '20vh',
      disableClose: true,
      data: {
        edit: {
          editID: editId,
          encryId: encID
        }
      }
    }).afterClosed().subscribe(() => this.getBodyPartsData());
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(BodypartsModalComponent, {
      minWidth: '60vw',
      minHeight: '20vh',
      disableClose: true
    }).afterClosed().subscribe(() => this.getBodyPartsData());
  }

  deleteDialog(i): void {
    this.deleteModalService.openModal({
      id: this.bodyParts[i].id,
      encId: this.bodyParts[i].enc_id,
      deleteUrl: '/body_parts/destroy'
    });

    this.deleteModalService.closed.subscribe(() => {
      this.commonAlertService.showEdit({message: 'Record Deleted Successfully'});
      this.getBodyPartsData();
    });
  }

  doSearch(): void {

  if (this.searchBy != null) {
      switch (this.searchBy) {
        case '0':
          Object.assign(this.filter, {search: { type: 'str', field: 'body_parts.name', text: this.searchTxt}});
          break;
        default:
          Object.assign(this.filter, {search: { type: 'int', field: 'body_parts.name', text: this.searchTxt}});
      }
    }

    /*this.filter = {'search':{'type': this.searchBy.type, 'field': this.searchBy.field, 'text': this.searchTxt}};*/
  this.getBodyPartsData();
  }

   doRefresh(): void {
     this.searchTxt = null;
     this.filter = {
       token: localStorage.getItem('token')
     };
     this.getBodyPartsData();
  }

  doPaginate(e): void {
    Object.assign(this.filter, {page: e});
    this.getBodyPartsData();
  }

  selectRow(index: number) {
    this.selectedIndex = index;
  }

}
